import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { RootState, useAppDispatch } from "@store/index";
import { ShippingCaseResponse } from "@pages/shippingView/types";
import { Paper, Tab, Tabs, Tooltip } from "@mui/material";
import { ReportProblem } from "@mui/icons-material";
import {
  Outlet,
  useLocation,
  useNavigate,
  useOutletContext,
} from "react-router-dom";
import { fetchBillLading, fetchVoyage } from "./cargoSlice";

const CargoDetailsLayout = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { shipping } = useOutletContext<{ shipping: ShippingCaseResponse }>();

  const { loading, items, error } = useSelector(
    (state: RootState) => state.viewShipping.cargo.billOfLading,
  );
  const {
    loading: voyageLoading,
    items: voyageItems,
    error: voyageError,
  } = useSelector((state: RootState) => state.viewShipping.cargo.voyage);

  useEffect(() => {
    dispatch(fetchBillLading(shipping.id));
    dispatch(fetchVoyage(shipping.id));
  }, []);

  const hasNoVoyage =
    !voyageItems?.length && !voyageLoading && !voyageError && !!items?.length;

  const hasNoBills =
    !!voyageItems?.length && !loading && !error && !items?.length;

  const tabs = [
    { label: "Commodity Info", path: "commodity", warn: hasNoBills },
    { label: "Voyage Info", path: "voyage", warn: hasNoVoyage },
  ];

  const activeTab = tabs.findIndex((t) =>
    location.pathname.includes(`/cargo-details/${t.path}`),
  );

  return (
    <>
      <Tabs
        className="cargo"
        value={activeTab === -1 ? 0 : activeTab}
        onChange={(_, val) => navigate(tabs[val].path)}
      >
        {tabs.map((t) =>
          t.warn ? (
            <Tooltip
              key={t.path}
              title={
                t.path === "commodity"
                  ? "Missing commodities details. Complete commodities information to finalize your shipping case."
                  : "Missing voyage details. Complete voyage information to finalize your shipping case."
              }
            >
              <Tab
                icon={<ReportProblem color="warning" />}
                label={t.label}
                sx={{ flexDirection: "row", gap: "6px" }}
              />
            </Tooltip>
          ) : (
            <Tab key={t.path} label={t.label} />
          ),
        )}
      </Tabs>

      <Paper
        elevation={0}
        sx={{
          p: "24px 16px",
          border: "1px solid rgba(0, 0, 0, 0.12)",
          borderRadius: "0 4px 4px 4px",
        }}
      >
        <Outlet context={{ shipping }} />
      </Paper>
    </>
  );
};

export default CargoDetailsLayout;
